import React, { useState, useContext } from "react";
import "swiper/css";
import "swiper/css/zoom";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Zoom, Navigation, Pagination } from "swiper/modules";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import { AppContext } from "../context/ContenxtAPI";

const CardsSlider = ({
  priceIndex,
  tabIndexOfHomeownerOrLanlord,
  homeOwnerData,
  landdata,
}) => {
  const { setSelectedPlan } = useContext(AppContext);
  const handleFindOutMore = (id) => {
    setSelectedPlan(id);
  };
  console.log("priceindex", priceIndex, typeof priceIndex);
  console.log(
    "tab index of home or land",
    tabIndexOfHomeownerOrLanlord,
    typeof tabIndexOfHomeownerOrLanlord
  );

  let cards;

  if (tabIndexOfHomeownerOrLanlord === 0) {
    cards = homeOwnerData;
  } else if (tabIndexOfHomeownerOrLanlord === 1) {
    cards = landdata;
  }

  return (
    <div>
      <Swiper
        zoom={true}
        navigation={true}
        pagination={{
          clickable: true,
        }}
        modules={[Zoom, Navigation, Pagination]}
        spaceBetween={30}
        className="mySwiper"
      >
        {cards.map((item, i) => {
          const parts = item.title.split("+");
          return (
            <SwiperSlide key={i}>
              <div key={i} className="cards_staps">
                <div className="card_titles">
                  <h1>
                    {parts[0]}
                    {parts.length > 1 && (
                      <span style={{ color: "#7ff1ea", marginLeft: "3px" }}>+{parts[1]}
                      </span>
                    )}
                  </h1>
                  <p>{item.caption}</p>
                </div>
                <div className="cards_price">
                  <h1>{item.price[0]}</h1> p/m
                </div>
                <div className="cards_actions mt">
                  <div className="cards_actions">
                    {item.working.map((item, i) => (
                      <div className="working" key={i}>
                        <CheckCircleOutlineRoundedIcon
                          style={{ color: "#604CD4" }}
                        />
                        {item}
                      </div>
                    ))}
                  </div>
                  <div className="cards_actions">
                    {item?.notworking?.map((item, i) => (
                      <div className="notwarking" key={i}>
                        <CancelOutlinedIcon
                          style={{ color: "#604CD4", opacity: "0.67" }}
                        />
                        <span className="spanundesr">{item}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <Link to={`/FindOutMore/${item.id}`}>
                  <Button
                    variant="contained"
                    className="card_btn"
                    onClick={() => handleFindOutMore(item.id)}
                  >
                    Find Out More
                  </Button>
                </Link>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default CardsSlider;
